<template>
  <div id="app">
    <div v-if="loggingOut">
      <Loading text="Loading..." />
    </div>
    <div class="wrapper">
      <div
        class="wrapper-header"
        :class="{ isAccessCodeModalActive: isAccessCodeModalActive }"
      >
        <div class="menu-btn" @click="showHideSideBar">
          <span class="burger" :class="{ open: !isActive }"></span>
        </div>
        <p class="wrapper-header__username">{{ user.name }}</p>
        <div class="gemnote-logo">
          <a href="https://www.gemnote.com/" target="_blank" rel="noreferrer">
            <img :src="getLogoUrl(teamLogo)" />
          </a>
        </div>
      </div>
      <Sidebar />
      <div class="main-content">
        <ImpersonateNotification />
        <Notification />
        <transition name="fade">
          <div class="alert-api" v-if='false' v-show="subscriptionAlerts.length">
            <p
              v-html="
                subscriptionAlerts.map(alert => alert.message).join(' & ')
              "
            ></p>
          </div>
        </transition>
        <router-view :key="$route.path" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Notification from '../views/Notification'
import ImpersonateNotification from '../views/ImpersonateNotification'
import Sidebar from '@/components/Sidebar/Sidebar'
import LogoRender from '@/mixins/Util'
export default {
  name: 'PaigeDashboard',
  mixins: [LogoRender],
  components: {
    Notification,
    ImpersonateNotification,
    Sidebar
  },
  methods: {
    showHideSideBar() {
      this.$store.dispatch('globalTracking/displaySideBar')
    }
  },
  computed: mapState({
    user: state => state.profile.user,
    loggingOut: state => state.auth.loggingOut,
    isActive: state => state.globalTracking.isActive,
    subscriptionAlerts: state => state.billing.subscriptionAlerts,
    teamLogo: state => state.team.team.teamLogo.url,
    isAccessCodeModalActive: state => state.modal.isAccessCodeModalActive
  })
}
</script>

<style lang="scss">
@import '../global.scss';

.wrapper {
  position: absolute;
  width: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.main-content {
  height: 100%;
  margin-left: 300px;
}

.wrapper-header {
  display: none;
}

.menu-btn {
  position: relative;
  cursor: pointer;
  display: none;

  & .burger {
    position: absolute;
    right: 0;
    left: 0;
    top: 0rem;
    width: 25px;
    height: 2px;
    background: $onyx;
    transition: all 1s ease;
    transition-duration: 1s;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: -6px;
      width: 25px;
      height: 2px;
      background-color: $onyx;
      transition: all 1s ease;
      transition-duration: 1s;
    }

    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: 6px;
      width: 25px;
      height: 2px;
      background-color: $onyx;
      transition: all 1s ease;
      transition-duration: 1s;
    }

    &.open {
      background: transparent;

      &::before {
        transition: all 0.5s ease-in-out;
        transition-duration: 0.5s;
        transform: rotate(45deg) translate(2px, 8px);
      }

      &::after {
        transition: all 0.5s ease-in-out;
        transition-duration: 0.5s;
        transform: rotate(-45deg) translate(0px, -7px);
      }
    }
  }
}

/* css classes for alert api */
.alert-api {
  padding: 0.7rem 2rem;
  background-color: $alert-red;
  color: $onyx;
  position: sticky;
  width: 100%;
  top: 0;
  z-index: 99;

  p {
    text-align: center;
    margin: 0;
  }
}

@media (max-width: 1200px) {
  .wrapper-header {
    padding: 0px 1.2rem;
    border-bottom: 2px solid #514d43;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 65px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 99999;
    background-color: #f5f2ee;

    .wrapper-header__username {
      font-family: $inter;
      font-weight: 600;
      font-size: 1rem;
      text-align: center;
    }
    &.isAccessCodeModalActive {
      z-index: -1;
    }

    .gemnote-logo {
      text-align: left;

      a {
        &:hover {
          opacity: 1;
        }
      }

      img {
        width: auto;
        height: 1.55rem;
      }
    }
  }
  .main-content {
    width: auto;
    margin-left: 0px;
    position: relative;
    top: 1.5rem;
  }

  .notifications {
    width: 100%;
    margin: 0px 0px;
  }

  .menu-btn {
    display: block;
  }
}

// @media (max-width: 575.98px) {
//   .wrapper {
//     width: auto;
//   }
// }

// @media (min-width: 576px) and (max-width: 767.98px) {
//   .wrapper {
//     width: auto;
//   }
// }
</style>
